var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"test_ueditor"}},[_c('div',{attrs:{"id":"test_echart"}},[_c('Ueditor',{on:{"ready":_vm.editorReady}})],1),_c('div',{staticClass:"but",on:{"click":_vm.fuzhi}},[_vm._v("赋值")]),_c('div',{staticClass:"but",on:{"click":_vm.makesure}},[_vm._v("确定")]),_c('div',{staticClass:"con",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }